/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "models": {
            "nested": {
              "EstimatedTransferEvent": {
                "fields": {
                  "type": {
                    "type": ".squareup.sfs.models.EstimatedTransferEvent.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "estimatedTime": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "friendlyType": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "friendlyDescription": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "TRANSFER_EVENT_TYPE_DO_NOT_USE": 0,
                      "INITIATED": 1,
                      "SETTLED": 2,
                      "MADE_AVAILABLE": 3
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.models?.nested?.EstimatedTransferEvent && !$root.nested?.squareup?.nested?.sfs?.nested?.models?.nested?.EstimatedTransferEvent?.nested?.Type) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc An event representing a change in state for a given Transfer, and when we believe it will occur.
 * Used to construct an estimated timeline when a Transfer is created. Mostly applicable to external transfers,
 * since any type of instant transfer will settle/be available instantly.
 *
 * Best effort to match the CorePro values of createdTime, settledTime, and availableTime as closely as possible.
 *
 * INITIATIED => SETTLED => MADE_AVAILABLE
 * --
 *
 * SOURCE EstimatedTransferEvent @ squareup/sfs/models/estimated_transfer_event.proto at 16:1
 */
export const EstimatedTransferEvent = $root.lookupType('squareup.sfs.models.EstimatedTransferEvent');
fixType(EstimatedTransferEvent, {
  type: {
    required: true
  },
  estimatedTime: {
    required: true
  },
  friendlyType: {
    required: true
  }
});
Builder.createAndAttachToType(EstimatedTransferEvent);
/**
 * SOURCE Type @ squareup/sfs/models/estimated_transfer_event.proto at 17:3
 */
EstimatedTransferEvent.Type = $root.lookupEnum('squareup.sfs.models.EstimatedTransferEvent.Type').values;